import React from 'react'
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { IoIosCheckmark, IoIosClose, IoMdBowtie } from 'react-icons/io'

const StepIndicatorItem = (props) => {

   const {
      handleClick,
      idx,
      name,
      currentStepIndex,
      showValidationResult = false,
      isValid = false,
      openOptionsOnClick = false
   } = props

   let bgColor = idx < currentStepIndex ? 'bg-secondary opacity-50' : 'bg-secondary'
   if (idx === currentStepIndex) {
      bgColor = 'bg-dark'
   }

   return (
      <li className='stepIndicator' onClick={(evt) => {
         handleClick(evt, idx)
      }}>
         <OverlayTrigger
            placement='top'
            overlay={
               <Tooltip id='tooltip-top' >
                  {name}
               </Tooltip>
            }
         >
            <div >
               <div className={`${bgColor} stepIndicatorBar`}>
               </div>
               <div className='text-center d-flex justify-content-center' style={{ height: '20px' }}>
                  <IoIosCheckmark color='green' size={20} className={showValidationResult && isValid ? 'fadeIn' : 'fadeOut'} style={{ position: 'absolute' }} />
                  <IoIosClose color='red' size={20} className={showValidationResult && !isValid ? 'fadeIn' : 'fadeOut'} style={{ position: 'absolute' }} />
               </div>
               <div className='text-center d-flex justify-content-center'>
                  <Badge className={`${bgColor} stepIndicatorBadge `} pill>
                     {idx + 1}
                  </Badge>
               </div>
            </div >
         </OverlayTrigger >
      </li >
   )
}
export default StepIndicatorItem